/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

type SidebarItemWrapperProps = {
  onClick: () => void;
  hasIcon?: boolean;
  hideBottomBorder?: boolean;
};

export const SidebarItemWrapper = styled.button<SidebarItemWrapperProps>`
  padding: ${({ hideBottomBorder }) =>
    `${hideBottomBorder ? theme.spacing.spacing02 : theme.spacing.spacing04} ${
      theme.spacing.spacing02
    }`};
  column-gap: ${theme.spacing.spacing03};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  width: 100%;
  background: none;
  border: none;
  border-bottom: ${({ hideBottomBorder }) =>
    hideBottomBorder ? "none" : `1px solid ${theme.color.border.border01}`};
  &:hover {
    cursor: pointer;
    background-color: ${theme.color.background.ui03};
  }

  &:disabled {
    opacity: 0.5;
    background-color: ${theme.color.interactive.disabled};
    color: ${theme.color.text.text03};
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const SidebarIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
